import { useState } from 'react';
import { faqData, aboutData, rankingData, indexData } from '@/mocks/51cgHomeData';

export function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <section id="faq" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2 text-center">
          吃瓜须知
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">关于51cg吃瓜网的常见问题解答</p>

        <div className="space-y-3">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenId(openId === item.id ? null : item.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400">
                  <i className={`text-lg transition-transform duration-300 ${openId === item.id ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === item.id ? 'max-h-[500px] pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2 text-center">
          {aboutData.title}
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">了解我们的故事与使命</p>

        <div className="rounded-2xl bg-background-50 border border-background-200/70 p-6 md:p-8">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            {aboutData.content}
          </p>
        </div>
      </div>
    </section>
  );
}

export function RankingSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const tagColors: Record<string, string> = {
    '爆': 'bg-accent-500 text-white',
    '热': 'bg-secondary-500 text-white',
    '新': 'bg-primary-500 text-white',
  };

  return (
    <section id="ranking" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <div className="flex items-end justify-between mb-2">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            热度榜单
          </h2>
          <a
            href="#index"
            onClick={(e) => handleNavClick(e, '#index')}
            className="text-xs md:text-sm text-accent-500 hover:text-accent-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line text-xs"></i>
          </a>
        </div>
        <p className="text-sm text-foreground-500 mb-6">实时追踪最受关注的51cg爆料与吃瓜话题</p>

        <div className="space-y-2">
          {rankingData.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 px-4 py-3 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-200 transition-colors cursor-pointer group"
            >
              <span className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold ${
                item.rank <= 3 ? 'bg-accent-500 text-white' : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </span>
              <span className="flex-1 text-sm md:text-base text-foreground-800 group-hover:text-accent-600 transition-colors line-clamp-1">
                {item.title}
              </span>
              <span className={`flex-shrink-0 px-2 py-0.5 rounded-full text-xs font-medium ${tagColors[item.tag] || 'bg-background-200 text-foreground-500'}`}>
                {item.tag}
              </span>
              <span className="flex-shrink-0 text-xs text-foreground-400 w-14 text-right">
                {item.hot}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function IndexSection() {
  const colorMap: Record<string, string> = {
    accent: 'bg-accent-100/80 text-accent-700',
    primary: 'bg-primary-100/80 text-primary-700',
    secondary: 'bg-secondary-100/80 text-secondary-700',
  };

  return (
    <section id="index" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2 text-center">
          吃瓜导航
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">快速找到你感兴趣的51cg吃瓜内容</p>

        <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexData.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 transition-colors cursor-pointer group"
            >
              <span className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl ${colorMap[item.color]} text-lg md:text-xl transition-transform group-hover:scale-110`}>
                <i className={item.icon}></i>
              </span>
              <span className="text-xs md:text-sm font-semibold text-foreground-800 text-center whitespace-nowrap">
                {item.title}
              </span>
              <span className="text-[10px] md:text-xs text-foreground-400 text-center hidden sm:block">
                {item.desc}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}